module.exports = "/images/graduation.png?5ad2d0da20be93ff2962961d007bb137";